import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { backendImageUrl, RoutesPaths } from "../Router/constant";
import Modal from "react-bootstrap/Modal";
import { logoutAction, profileAdminDetails } from "../actions/auth";
import { useDispatch, useSelector } from "react-redux";

export default function Sidebar({ showAside }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { profileDetails, profileDetailsLoader } = useSelector(
    (state) => state.auth,
  );

  const handleUserLogout = () => {
    logoutAction();
    navigate(RoutesPaths.LOGIN);
    setShow(false);
  };

  useEffect(() => {
    dispatch(profileAdminDetails());
  }, []);

  return (
    <>
      <div className={`aside ${showAside ? "aside-on" : ""}`}>
        <div className="aside-toolbar flex-column-auto">
          <div className="aside-user d-flex align-items-sm-center justify-content-center py-5">
            <div className="symbol symbol-50px">
              {profileDetails?.data?.photo?.fileName ? (
                <img
                  src={backendImageUrl + profileDetails?.data?.photo?.fileName}
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              ) : (
                <img src="/assets/media/avatars/blank.png" alt="" />
              )}
            </div>
            <div className="aside-user-info flex-row-fluid flex-wrap ms-5">
              <div className="d-flex">
                <div className="flex-grow-1 me-2">
                  <NavLink
                    to="#"
                    className="text-white text-hover-primary fs-6 fw-bold"
                  >
                    {profileDetails?.data?.name}
                  </NavLink>
                  <span className="text-gray-600 fw-semibold d-block fs-8 mb-1">
                    {profileDetails?.data?.role}
                  </span>
                  <div className="d-flex align-items-center text-success fs-9">
                    <span className="bullet bullet-dot bg-success me-1"></span>
                    online
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="aside-menu flex-column-fluid">
          <div className="mx-3 my-5 my-lg-5">
            <div className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500">
              <div className="menu-item menu-accordion ">
                <NavLink
                  to={RoutesPaths.DASHBOARD}
                  className={() =>
                    `menu-link ${location.pathname.startsWith(RoutesPaths.DASHBOARD)
                      ? "Activeaccordion"
                      : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-element-plus fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                      <span className="path3 whiteColor"></span>
                      <span className="path4 whiteColor"></span>
                      <span className="path5 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Dashboard</span>
                </NavLink>
              </div>
              <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.USERS}
                  className={() =>
                    `menu-link ${location.pathname.startsWith(RoutesPaths.USERS)
                      ? "Activeaccordion"
                      : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-user fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Users</span>
                </NavLink>
              </div>
              <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.CATEGORIES}
                  className={({ isActive }) =>
                    `menu-link ${isActive ? "Activeaccordion" : ""}`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-file fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Categories</span>
                </NavLink>
              </div>
              <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.STORS}
                  className={() =>
                    `menu-link ${location.pathname.startsWith(RoutesPaths.STORS)
                      ? "Activeaccordion"
                      : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-abstract-39 fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Stores</span>
                </NavLink>
              </div>

              <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.BANNER}
                  className={() =>
                    `menu-link ${location.pathname.startsWith(RoutesPaths.BANNER)
                      ? "Activeaccordion"
                      : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-element-7 fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Banners</span>
                </NavLink>
              </div>

              {/* <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.PROMOTIONALBANNER}
                  className={() =>
                    `menu-link ${
                      location.pathname.startsWith(
                        RoutesPaths.PROMOTIONALBANNER,
                      )
                        ? "Activeaccordion"
                        : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-abstract-26 fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Promotional banners</span>
                </NavLink>
              </div> */}

              <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.CHATS}
                  className={() =>
                    `menu-link ${location.pathname.startsWith(RoutesPaths.CHATS)
                      ? "Activeaccordion"
                      : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-call fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                      <span className="path3 whiteColor"></span>
                      <span className="path4 whiteColor"></span>
                      <span className="path5 whiteColor"></span>
                      <span className="path6 whiteColor"></span>
                      <span className="path7 whiteColor"></span>
                      <span className="path8 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Chats</span>
                </NavLink>
              </div>
              {/* <div className="menu-item menu-accordion">
                <NavLink
                  to={RoutesPaths.PROFILE}
                  className={() =>
                    `menu-link ${
                      location.pathname.startsWith(RoutesPaths.PROFILE)
                        ? "Activeaccordion"
                        : ""
                    }`
                  }
                >
                  <span className="menu-icon">
                    <i className="ki-duotone ki-chart-pie-3 fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                      <span className="path3 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">settings</span>
                </NavLink>
              </div> */}

              <div className="menu-item menu-accordion">
                <span className="menu-link" onClick={handleShow}>
                  <span className="menu-icon">
                    <i className="ki-duotone ki-chart-pie-3 fs-2">
                      <span className="path1 whiteColor"></span>
                      <span className="path2 whiteColor"></span>
                      <span className="path3 whiteColor"></span>
                    </i>
                  </span>
                  <span className="menu-title">Logout</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <div className="LogoutSection">
          <h6 className="m-0">Logout</h6>
          <p className="m-0">Are you sure you want to logout this account ?</p>
          <div className="logoutbuttonSection">
            <button
              className="redButton fontBthSize"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="greenButton fontBthSize"
              variant="primary"
              onClick={handleUserLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
